import { Constat } from './constat.model';
import { Notification } from './notification.model';
import { StatutManquement } from './statut-manquement.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Decision } from './decision.model';
import { Recours } from './recours.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Manquement {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idControle: { key: 'idControle', optional: true },
        numero: { key: 'numeroManquement', optional: true, default: '' },
        statut: { key: 'idStatut', converter: new (DataIdConverterFactory.build(StatutManquement, 'statutsManquement'))(), optional: true },
        idStatut: { key: 'idStatut', optional: true },
        constat: { key: 'constat', converter: new (ClassConverterFactory.build(Constat))(), optional: true },
        notification: { key: 'notification', converter: new (ClassConverterFactory.build(Notification))(), optional: true },
        decision: { key: 'decision', converter: new (ClassConverterFactory.build(Decision))(), optional: true },
        recours: { key: 'recours', converter: new (ClassConverterFactory.build(Recours))(), optional: true }
    };

    id: number;
    idControle: number;
    numero: string;
    statut: StatutManquement;
    idStatut: number;
    constat: Constat;
    notification: Notification;
    decision: Decision;
    recours: Recours;
}
